import React from "react";

import { MasonryGrid } from "../../../common/MasonryGrid";
import { GridItem } from "../interfaces";
import { GridTile } from "./GridTile";
import { ReviewSnippetTile } from "./ReviewSnippetTile";
import { TempurLoveStoryPageTile } from "./TempurLoveStoryPageTile";

interface IProps {
    data: GridItem[];
    appendItems?: boolean;
}

export const Grid = ({ data, appendItems }: IProps): React.ReactNode => {
    const primaryLinkRefs = React.useRef<
        Map<number, React.RefObject<HTMLAnchorElement | null>>
    >(new Map());

    const getOrCreateLinkRef = React.useCallback(
        (item: GridItem): React.RefObject<HTMLAnchorElement | null> => {
            const idx = data.indexOf(item);
            let ref = primaryLinkRefs.current.get(idx);
            if (ref) {
                return ref;
            }
            ref = React.createRef<HTMLAnchorElement>();
            primaryLinkRefs.current.set(idx, ref);
            return ref;
        },
        [data],
    );

    return (
        <div className="l-full-width">
            <div className="l-capped-width">
                <article className="posts">
                    <MasonryGrid
                        appendItems={appendItems}
                        className={"posts__container"}
                        itemSelector={".post"}
                        entities={data}
                        getTileID={(item) => `${item.id}`}
                        buildTile={(item, tileRef) => {
                            const linkRef = getOrCreateLinkRef(item);
                            return (
                                <GridTile
                                    key={item.id}
                                    forwardedRef={tileRef}
                                    primaryLinkRef={linkRef}
                                    tileUID={item.id}
                                >
                                    {(item.type === "cms.TempurLoveStoryPage" ||
                                        item.type ===
                                            "cms.CustomerContentHubStoryPage") && (
                                        <TempurLoveStoryPageTile
                                            data={item}
                                            ref={linkRef}
                                        />
                                    )}
                                    {(item.type ===
                                        "cms.TempurLoveReviewSnippetPage" ||
                                        item.type ===
                                            "cms.CustomerContentHubReviewSnippetPage") && (
                                        <ReviewSnippetTile
                                            data={item}
                                            ref={linkRef}
                                        />
                                    )}
                                </GridTile>
                            );
                        }}
                        emptyState={null}
                        options={{
                            horizontalOrder: true,
                            gutter: 10,
                        }}
                    />
                </article>
            </div>
        </div>
    );
};
